
import PdvDesktopAuthService from "../services/PdvDesktopAuthService";
import TerminalConfigService from "../services/TerminalConfigService";
import BrandService from "../services/BrandService";

export default {
  name: "PdvDesktopLoginPage",

  data() {
    return {
      brandName: BrandService.productName,
      online: typeof navigator !== "undefined" ? navigator.onLine : true,
      temSessaoSalva: false,
      temCacheOffline: false,

      form: { email: "", senha: "" },
      erros: { email: "", senha: "" },

      erroLogin: "",
      carregando: false,
      mostrarSenha: false,
      lembrarSenha: false,
    };
  },

  async created() {
    BrandService.carregar().then(() => { this.brandName = BrandService.productName; });
    this._onOnline  = () => { this.online = true; };
    this._onOffline = () => { this.online = false; };
    window.addEventListener("online",  this._onOnline);
    window.addEventListener("offline", this._onOffline);

    if (this.$isDesktop) {
      const [sessao, email, cache, credencialLembrada] = await Promise.all([
        TerminalConfigService.temSessaoSalva(),
        TerminalConfigService.getEmailSalvo(),
        PdvDesktopAuthService.temCredencialOffline(),
        this.$electron.credenciaisLogin?.buscar().catch(() => null),
      ]);
      this.temSessaoSalva = sessao;
      this.temCacheOffline = cache;
      if (credencialLembrada) {
        this.form.email = credencialLembrada.identificador || "";
        this.form.senha = credencialLembrada.senha || "";
        this.lembrarSenha = true;
      } else if (email) {
        this.form.email = email;
      }
    }
  },

  beforeDestroy() {
    window.removeEventListener("online",  this._onOnline);
    window.removeEventListener("offline", this._onOffline);
  },

  methods: {
    _validar() {
      let ok = true;
      this.erros = { email: "", senha: "" };

      // Offline ou online, sempre exigimos e-mail e senha — no modo offline a
      // senha é validada contra o cache local (hash), não contra o servidor.
      if (!this.form.email) {
        this.erros.email = "Informe o e-mail ou usuário.";
        ok = false;
      }
      if (!this.form.senha) {
        this.erros.senha = "Informe a senha.";
        ok = false;
      }
      return ok;
    },

    async entrar() {
      this.erroLogin = "";
      if (!this._validar()) return;

      this.carregando = true;
      try {
        if (!this.online) {
          // ── Modo offline: valida credenciais contra o cache local ───────
          if (!this.temCacheOffline) {
            this.erroLogin =
              "É necessário fazer o primeiro login com internet neste terminal.";
            return;
          }
          await PdvDesktopAuthService.loginOffline(this.form.email, this.form.senha);
        } else {
          // ── Modo online: autentica no servidor ─────────────────────────
          await PdvDesktopAuthService.login(this.form.email, this.form.senha);
        }

        await this._salvarPreferenciaCredencial();
        await this._redirecionar();

      } catch (e) {
        this.erroLogin =
          e.message || "Não foi possível autenticar. Tente novamente.";
      } finally {
        this.carregando = false;
      }
    },

    async _salvarPreferenciaCredencial() {
      const credenciaisLogin = this.$electron?.credenciaisLogin;
      if (!this.$isDesktop) return;

      if (!credenciaisLogin) {
        if (this.lembrarSenha) {
          throw new Error(
            "Feche e abra novamente o PDV Desktop para ativar a opção Lembrar-me."
          );
        }
        return;
      }

      if (this.lembrarSenha) {
        await credenciaisLogin.salvar({
          identificador: this.form.email,
          senha: this.form.senha,
        });
      } else {
        try {
          await credenciaisLogin.limpar();
        } catch (_) {
          // A limpeza da preferência não deve impedir um login válido.
        }
      }
    },

    /**
     * Após autenticação bem-sucedida, verifica se o terminal já está
     * configurado e redireciona para a tela correta.
     */
    async _redirecionar() {
      const { configurado } = await TerminalConfigService.verificarConfiguracaoLocal();
      if (configurado) {
        if (this.online) {
          try {
            await TerminalConfigService.garantirTerminalAutorizado({ forcar: true });
          } catch (e) {
            if (TerminalConfigService.isCodigoBloqueioEmpresa(e?.code)) {
              this.$router.push({ name: "pdvDesktopBloqueio" });
              return;
            }
            this.$router.push({ name: "pdvDesktopConfiguracaoTerminal" });
            return;
          }
        }
        this.$router.push({ name: "pdvDesktopDashboard" });
      } else {
        this.$router.push({ name: "pdvDesktopConfiguracaoTerminal" });
      }
    },
  },
};
